import { render, staticRenderFns } from "./ThreeCompositionElement.vue?vue&type=template&id=618d3ae2&"
import script from "./ThreeCompositionElement.vue?vue&type=script&lang=js&"
export * from "./ThreeCompositionElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports